export default __webpack_public_path__ + "static/media/appointment.989ce81b.png";